import { render, staticRenderFns } from "./ColumnsPreferencesConfigModal.vue?vue&type=template&id=fbce49e4&"
import script from "./ColumnsPreferencesConfigModal.vue?vue&type=script&lang=js&"
export * from "./ColumnsPreferencesConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./ColumnsPreferencesConfigModal.vue?vue&type=style&index=0&id=fbce49e4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports